import React from 'react'
import { Helmet } from 'react-helmet'
import PropTypes from 'prop-types'

import AuthProTemplate from 'templates/AuthProTemplate'
import FormView from 'components/SignInSignUp/SignInView/SignInForm/View/Pro'

const LoginFormPro = ({ error, handleSubmit, isLoading, translate }) => (
  <>
    <Helmet>
      <title>{translate('pro.content.title_page')}</title>
    </Helmet>
    <AuthProTemplate
      title={translate('pro.login.title')}
      description={translate('pro.login.description')}
    >
      <FormView
        handleSubmit={handleSubmit}
        isLoading={isLoading}
        error={error}
        translate={translate}
      />
    </AuthProTemplate>
  </>
)

LoginFormPro.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  error: PropTypes.string,
  translate: PropTypes.func,
}

export default LoginFormPro
